<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (project && logicalConfig) {
    <div class="form-group row justify-content-center mt-3">
        <span class="form-label col-3 mt-auto">{{ 'project.name' | translate }}</span>
        <div class="col-8">
            <sui-string-component [config]="suiProject.name" [readonly]="viewInReadOnly()"></sui-string-component>
        </div>
    </div>
    <div class="form-group row justify-content-center">
        <span class="form-label col-3 mt-auto">{{ 'project.description' | translate }}</span>
        <div class="col-8">
            <sui-string-component [config]="suiProject.description" [readonly]="viewInReadOnly()"></sui-string-component>
        </div>
    </div>
    <div class="form-group row justify-content-center">
        <span class="form-label col-3 mt-auto" style="white-space: nowrap">Price discount (%)</span>
        <div class="col-8">
            <sui-number-component [config]="suiLogicalConfig.basic_discount" [readonly]="viewInReadOnly()"></sui-number-component>
        </div>
    </div>
    <div class="form-group row justify-content-center">
        <span class="form-label col-3 mt-auto">Project units</span>
        @if (logicalConfig().crs.properties.productUnits) {
            <div class="col-8 justify-content-start" style="padding-top: 6px">
                <sui-radio-group-component [config]="inputProductUnits"></sui-radio-group-component>
            </div>
        }
    </div>
    <div class="form-group row justify-content-center">
        <span class="toggle-btn-text col-3">Use layers</span>
        <div class="col-8">
            <sui-toggle-component [config]="suiLogicalConfig.layersModeEnabled"></sui-toggle-component>
            @if (hasStationsWithLayers) {
                <small class="btn-disabled-reason-text"> The project has locations mapped to layers</small>
            }
        </div>
    </div>
    <div class="form-group row justify-content-center mt-3">
        <span class="form-label col-3 mt-auto">{{ 'project.locationNamesPrefix' | translate }}</span>
        <div class="col-8">
            <sui-string-component [config]="suiLogicalConfig.locationNamePrefix" [readonly]="viewInReadOnly()"></sui-string-component>
        </div>
    </div>
    @if (authorizationManagerService.canCreateAreaPlannerProject()) {
        <div class="form-group row justify-content-center mt-3">
            <span class="form-label col-3 mt-auto">{{ 'project.areaPlannerProject' | translate }}</span>
            <div class="col-8">
                <sui-toggle-component [config]="areaPlannerProjectToggle"></sui-toggle-component>
            </div>
        </div>
    }
}
